import type { NuxtUiTheme } from '../types/nuxt-ui-theme';

const headCellStyles =
    'rounded-md font-(family-name:--primary-font) text-xs font-extrabold tracking-[0.04em] uppercase ' +
    'text-(--text-dark)!';
const cellTriggerStyles =
    'data-today:not-data-selected:bg-transparent! data-today:not-data-selected:text-(--accent-solid)! ' +
    'data-today:not-data-selected:ring! data-today:not-data-selected:ring-inset! ' +
    'data-today:not-data-selected:ring-(--slate-alpha-35)! data-highlighted:bg-(--slate-alpha-10)! ' +
    'data-highlighted:text-(--text-dark)! data-selected:bg-(image:--accent-gradient)! ' +
    'data-selected:text-(--pure-white)! data-selected:font-bold data-selected:ring-0! ' +
    'data-selected:shadow-(--progress-glow-shadow-sm)!';

export default {
    slots: {
        root: 'text-(--input-neumorphic-text)!',
        header:
            'flex items-center justify-between [&_button:hover]:bg-none! [&_button:hover]:bg-(--slate-alpha-10)! ' +
            '[&_button:focus-visible]:bg-none! [&_button:focus-visible]:bg-(--slate-alpha-10)! ' +
            '[&>button:not(:disabled)]:text-(--text-dark)! ' +
            '[&>button:not(:disabled)>[data-slot=leadingIcon]]:text-(--text-dark)!',
        body: 'flex flex-col space-y-4 pt-4 sm:flex-row sm:space-x-4 sm:space-y-0',
        heading:
            'mx-auto truncate text-center font-(family-name:--primary-font) text-sm font-semibold ' +
            'text-(--text-dark)! [&>button]:text-(--text-dark)! [&>button:hover]:text-(--text-dark)! ' +
            '[&>button:focus-visible]:text-(--text-dark)!',
        grid: 'w-full border-collapse select-none space-y-1 focus:outline-none',
        gridRow: 'grid grid-cols-7 place-items-center',
        gridWeekDaysRow: 'mb-1 grid w-full grid-cols-7',
        gridBody: 'grid',
        headCell: headCellStyles,
        headCellWeek: headCellStyles,
        cell: 'relative text-center text-sm',
        cellWeek: 'relative text-center text-xs text-(--text-muted)!',
        cellTrigger:
            'm-0.5 relative flex size-8 items-center justify-center rounded-full whitespace-nowrap ' +
            'font-(family-name:--primary-font) font-semibold transition-[background,color] duration-200 ease-in-out ' +
            'focus:outline-none text-(--text-light)! data-disabled:pointer-events-none data-disabled:opacity-40 ' +
            'data-disabled:text-(--text-muted)! data-unavailable:pointer-events-none data-unavailable:line-through ' +
            'data-unavailable:text-(--text-muted)! data-outside-view:opacity-45 ' +
            'data-outside-view:text-(--text-muted)! data-today:not-data-selected:font-extrabold ' +
            'data-today:not-data-selected:bg-transparent! data-today:not-data-selected:text-(--accent-solid)! ' +
            'data-today:not-data-selected:ring! data-today:not-data-selected:ring-inset! ' +
            'data-today:not-data-selected:ring-(--slate-alpha-35)! data-highlighted:bg-(--slate-alpha-10)! ' +
            'data-highlighted:text-(--text-dark)! hover:not-data-selected:bg-(--slate-alpha-14)! ' +
            'hover:not-data-selected:text-(--text-dark)! ' +
            'hover:not-data-selected:shadow-[0_0.125rem_0.375rem_rgba(100,116,139,0.12)]! ' +
            'data-selected:bg-(image:--accent-gradient)! data-selected:text-(--pure-white)! data-selected:font-bold ' +
            'data-selected:ring-0! data-selected:shadow-(--progress-glow-shadow-sm)! ' +
            'data-selected:hover:text-(--pure-white)! data-selected:focus:text-(--pure-white)! active:scale-[0.94]'
    },
    variants: {
        color: {
            primary: {
                headCell: 'text-(--text-dark)!',
                cellTrigger: 'focus-visible:ring-(--accent-solid)!'
            },
            neutral: {
                headCell: 'text-(--text-dark)!',
                cellTrigger: 'focus-visible:ring-(--accent-solid)!'
            }
        },
        variant: {
            solid: '',
            outline: '',
            soft: '',
            subtle: ''
        },
        size: {
            xs: {
                heading: 'text-xs',
                cell: 'text-xs',
                cellWeek: 'text-xs',
                headCell: 'text-[0.625rem]',
                headCellWeek: 'text-[0.625rem]',
                cellTrigger: 'size-7',
                body: 'space-y-2 pt-2'
            },
            sm: {
                heading: 'text-xs',
                headCell: 'text-xs',
                headCellWeek: 'text-xs',
                cellWeek: 'text-xs',
                cell: 'text-xs',
                cellTrigger: 'size-7'
            },
            md: {
                heading: 'text-sm',
                headCell: 'text-xs',
                headCellWeek: 'text-xs',
                cellWeek: 'text-xs',
                cell: 'text-sm',
                cellTrigger: 'size-8'
            },
            lg: {
                heading: 'text-md',
                headCell: 'text-md',
                headCellWeek: 'text-md',
                cellTrigger: 'size-9 text-md'
            },
            xl: {
                heading: 'text-lg',
                headCell: 'text-lg',
                headCellWeek: 'text-lg',
                cellTrigger: 'size-10 text-lg'
            }
        },
        weekNumbers: {
            true: {
                gridRow: 'grid-cols-8',
                gridWeekDaysRow: 'grid-cols-8 [&>*:first-child]:col-start-2'
            }
        }
    },
    compoundVariants: [
        {
            color: 'primary',
            variant: 'solid',
            class: {
                headCell: 'text-(--text-dark)!',
                cellTrigger: cellTriggerStyles
            }
        },
        {
            color: 'neutral',
            variant: 'solid',
            class: {
                headCell: 'text-(--text-dark)!',
                cellTrigger: cellTriggerStyles
            }
        }
    ],
    defaultVariants: {
        size: 'md',
        color: 'neutral',
        variant: 'solid'
    }
} satisfies NuxtUiTheme['calendar'];
